import { useQuery, useMutation, useQueryClient } from "react-query";
import { useApi } from "@/api/useApi";

interface AggregatedAutoResponseConfig {
  aggregatedResponseEnabled: boolean;
  aggregatedWindowMinutes: number;
}

interface UpdateAggregatedAutoResponseParams {
  aggregatedResponseEnabled?: boolean;
  aggregatedWindowMinutes?: number;
}

const AGGREGATED_AUTO_RESPONSE_QUERY_KEY = "aggregated-auto-response-config";

export const useGetAggregatedAutoResponseConfig = () => {
  const { api } = useApi();
  return useQuery<AggregatedAutoResponseConfig>(
    [AGGREGATED_AUTO_RESPONSE_QUERY_KEY],
    async () => {
      const response = await api.get("/platform/auto-activate/aggregated-config");
      return response.data;
    },
    {
      retry: 1,
      staleTime: 5 * 60 * 1000,
    }
  );
};

export const useUpdateAggregatedAutoResponseConfig = () => {
  const queryClient = useQueryClient();
  const { api } = useApi();

  return useMutation<AggregatedAutoResponseConfig, Error, UpdateAggregatedAutoResponseParams>(
    async (params: UpdateAggregatedAutoResponseParams) => {
      const response = await api.put("/platform/auto-activate/aggregated-config", params);
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([AGGREGATED_AUTO_RESPONSE_QUERY_KEY]);
      },
    }
  );
};
